import { render } from "./RecoverForm.vue?vue&type=template&id=7c7572a8&scoped=true"
import script from "./RecoverForm.vue?vue&type=script&lang=js"
export * from "./RecoverForm.vue?vue&type=script&lang=js"

import "./RecoverForm.vue?vue&type=style&index=0&id=7c7572a8&scoped=true&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c7572a8"]])

export default __exports__